


// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// function Achievements() {
//   const certificates = [
//     { src: "/certificates/Certificate1.jpg", title: "Asian International Book of World Record" },
//     { src: "/certificates/Certificate2.jpg", title: "International European Book of World Record" },
//     { src: "/certificates/Certificate3.jpg", title: "International WAC Book of World Record" },
//     { src: "/certificates/Certificate4.jpg", title: "USA International Book of World Record" },
//     { src: "/certificates/Certificate5.jpg", title: "London International Book of World Record" },
//     { src: "/certificates/Certificate6.jpg", title: "India Proud Book of Records" },
//     { src: "/certificates/Certificate7.jpg", title: "International Book of World Records" },
//   ];

//   const [selectedImage, setSelectedImage] = useState(null);

//   return (
//     <div className="container mt-5 mb-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
//       {/* 🌅 Hero Section */}
//       <motion.section
//         className="text-center text-dark"
//         initial={{ opacity: 0, y: -60 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 1 }}
//         style={{
//           background: "linear-gradient(120deg, #ffe0b5, #fff3e1, #ffe7c2)",
//           padding: "70px 20px",
//           borderRadius: "20px",
//           boxShadow: "0 8px 30px rgba(255,200,100,0.3)",
//           position: "relative",
//           overflow: "hidden",
//         }}
//       >
//         {/* Soft glow element */}
//         <motion.div
//           animate={{ rotate: 360 }}
//           transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
//           style={{
//             position: "absolute",
//             width: "300px",
//             height: "300px",
//             background:
//               "radial-gradient(circle, rgba(255,255,255,0.35) 0%, transparent 70%)",
//             top: "-50px",
//             left: "-50px",
//             borderRadius: "50%",
//             filter: "blur(60px)",
//           }}
//         />

//         <motion.h1
//           className="display-4"
//           initial={{ opacity: 0, scale: 0.8 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 1, delay: 0.3 }}
//           style={{
//             fontWeight: "800",
//             fontSize: "3rem",
//             letterSpacing: "1px",
//             color: "#5a3a0e",
//             textShadow: "0 2px 8px rgba(255,210,150,0.5)",
//           }}
//         >
//           Achievements & Certificates
//         </motion.h1>

//         <motion.p
//           className="lead"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 1, delay: 0.6 }}
//           style={{
//             fontSize: "1.25rem",
//             marginTop: "20px",
//             color: "#6b4a2e",
//             opacity: 0.9,
//             maxWidth: "750px",
//             margin: "20px auto 0",
//           }}
//         >
//           Celebrating the global honors and record-breaking achievements of  
//           <br />
//           <strong>Acharya Dr. Pranamsagar Ji Maharaj</strong>
//         </motion.p>
//       </motion.section>

//       {/* 🖼 Certificates Gallery */}
//       <motion.section
//         className="mt-5 p-4"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         transition={{ duration: 0.8 }}
//         style={{
//           background: "linear-gradient(to bottom, #fffaf3, #fff3e1)",
//           borderRadius: "20px",
//           boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
//           backdropFilter: "blur(6px)",
//         }}
//       >
//         <h2
//           className="text-center mb-4"
//           style={{
//             color: "#b66b00",
//             fontWeight: "700",
//             fontSize: "2.4rem",
//             letterSpacing: "1px",
//           }}
//         >
//           Certificates Gallery
//         </h2>

//         <div className="row justify-content-center">
//           {certificates.map((cert, i) => (
//             <motion.div
//               key={i}
//               className="col-sm-6 col-md-4 col-lg-3 mb-4"
//               initial={{ opacity: 0, scale: 0.9 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5, delay: i * 0.1 }}
//             >
//               <motion.div
//                 whileHover={{
//                   scale: 1.05,
//                   boxShadow: "0 10px 25px rgba(255,180,100,0.4)",
//                 }}
//                 onClick={() => setSelectedImage(cert)}
//                 style={{
//                   background: "#fffaf3",
//                   borderRadius: "16px",
//                   overflow: "hidden",
//                   border: "1px solid rgba(255,200,150,0.4)",
//                   cursor: "pointer",
//                   transition: "all 0.4s ease",
//                   boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 <motion.img
//                   src={cert.src}
//                   alt={cert.title}
//                   whileHover={{ scale: 1.05 }}
//                   transition={{ duration: 0.3 }}
//                   style={{
//                     width: "100%",
//                     height: "250px",
//                     objectFit: "cover",
//                     borderBottom: "3px solid #e4a144",
//                     transition: "all 0.4s ease",
//                   }}
//                 />
//                 <div
//                   style={{
//                     padding: "14px",
//                     textAlign: "center",
//                     fontWeight: "600",
//                     color: "#5a3a0e",
//                     fontSize: "1.05rem",
//                     backgroundColor: "#fffaf3",
//                   }}
//                 >
//                   {cert.title}
//                 </div>
//               </motion.div>
//             </motion.div>
//           ))}
//         </div>
//       </motion.section>

//       {/* 🌌 Lightbox */}
//       <AnimatePresence>
//         {selectedImage && (
//           <motion.div
//             key="lightbox"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             style={{
//               position: "fixed",
//               inset: 0,
//               background: "rgba(0,0,0,0.85)",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               zIndex: 9999,
//               backdropFilter: "blur(8px)",
//             }}
//           >
//             {/* Close Button */}
//             <motion.button
//               onClick={() => setSelectedImage(null)}
//               initial={{ opacity: 0, y: -10 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.3 }}
//               style={{
//                 position: "absolute",
//                 top: "25px",
//                 right: "35px",
//                 background: "transparent",
//                 border: "none",
//                 color: "#fff",
//                 fontSize: "2.5rem",
//                 cursor: "pointer",
//                 fontWeight: "bold",
//               }}
//             >
//               &times;
//             </motion.button>

//             {/* Image */}
//             <motion.img
//               src={selectedImage.src}
//               alt={selectedImage.title}
//               initial={{ scale: 0.85, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               exit={{ scale: 0.8, opacity: 0 }}
//               transition={{ duration: 0.4 }}
//               style={{
//                 maxWidth: "90%",
//                 maxHeight: "85%",
//                 borderRadius: "12px",
//                 boxShadow: "0 0 25px rgba(255,255,255,0.3)",
//                 objectFit: "contain",
//               }}
//             />

//             {/* Caption */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.4, delay: 0.2 }}
//               style={{
//                 position: "absolute",
//                 bottom: "30px",
//                 textAlign: "center",
//                 color: "#fff",
//                 fontWeight: "600",
//                 fontSize: "1.2rem",
//                 textShadow: "0 0 10px rgba(0,0,0,0.6)",
//                 padding: "0 10px",
//               }}
//             >
//               {selectedImage.title}
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* 📱 Responsive Styles */}
//       <style>
//         {`
//           @media (max-width: 992px) {
//             h1 { font-size: 2.2rem !important; }
//             h2 { font-size: 2rem !important; }
//             p { font-size: 1.05rem !important; }
//             img { height: 220px !important; }
//           }

//           @media (max-width: 576px) {
//             h1 { font-size: 1.8rem !important; }
//             h2 { font-size: 1.5rem !important; }
//             p { font-size: 0.95rem !important; }
//             img { height: 200px !important; }
//             .col-sm-6 { flex: 0 0 100% !important; max-width: 100% !important; }
//             button { font-size: 1.8rem !important; top: 15px !important; right: 20px !important; }
//           }
//         `}
//       </style>
//     </div>
//   );
// }

// export default Achievements;


import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

function Achievements() {
  const certificates = [
    { src: "/certificates/Certificate1.jpg", title: "Asian International Book of World Record" },
    { src: "/certificates/Certificate2.jpg", title: "International European Book of World Record" },
    { src: "/certificates/Certificate3.jpg", title: "International WAC Book of World Record" },
    { src: "/certificates/Certificate4.jpg", title: "USA International Book of World Record" },
    { src: "/certificates/Certificate5.jpg", title: "London International Book of World Record" },
    { src: "/certificates/Certificate6.jpg", title: "India Proud Book of Records" },
    { src: "/certificates/Certificate7.jpg", title: "International Book of World Records" },
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div
      className="container mt-5 mb-5"
      style={{
        fontFamily: "'Poppins', sans-serif",
        padding: "0 15px",
        overflowX: "hidden",
      }}
    >
      {/* 🌅 Hero Section */}
      <motion.section
        className="text-center text-dark"
        initial={{ opacity: 0, y: -60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{
          background: "linear-gradient(120deg, #ffe0b5, #fff3e1, #ffe7c2)",
          padding: "60px 20px",
          borderRadius: "20px",
          boxShadow: "0 8px 30px rgba(255,200,100,0.3)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            background: "radial-gradient(circle, rgba(255,255,255,0.35) 0%, transparent 70%)",
            top: "-50px",
            left: "-50px",
            borderRadius: "50%",
            filter: "blur(60px)",
          }}
        />

        <motion.h1
          className="display-4"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          style={{
            fontWeight: "800",
            fontSize: "clamp(1.8rem, 4vw, 3rem)",
            letterSpacing: "1px",
            color: "#5a3a0e",
            textShadow: "0 2px 8px rgba(255,210,150,0.5)",
          }}
        >
          Achievements & Certificates
        </motion.h1>

        <motion.p
          className="lead"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          style={{
            fontSize: "clamp(1rem, 2vw, 1.25rem)",
            marginTop: "20px",
            color: "#6b4a2e",
            opacity: 0.9,
            maxWidth: "700px",
            margin: "20px auto 0",
            lineHeight: "1.6",
          }}
        >
          Celebrating the global honors and record-breaking achievements of <br />
          <strong>Acharya Dr. Pranamsagar Ji Maharaj</strong>
        </motion.p>
      </motion.section>

      {/* 🖼 Certificates Gallery */}
      <motion.section
        className="mt-5 p-4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        style={{
          background: "linear-gradient(to bottom, #fffaf3, #fff3e1)",
          borderRadius: "20px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
          backdropFilter: "blur(6px)",
        }}
      >
        <h2
          className="text-center mb-4"
          style={{
            color: "#b66b00",
            fontWeight: "700",
            fontSize: "clamp(1.5rem, 3vw, 2.4rem)",
            letterSpacing: "1px",
          }}
        >
          Certificates Gallery
        </h2>

        <div
          className="row justify-content-center"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1.5rem",
            justifyContent: "center",
          }}
        >
          {certificates.map((cert, i) => (
            <motion.div
              key={i}
              className="col-sm-6 col-md-4 col-lg-3"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              style={{
                flex: "1 1 280px",
                maxWidth: "320px",
              }}
            >
              <motion.div
                whileHover={{
                  scale: 1.03,
                  boxShadow: "0 10px 25px rgba(255,180,100,0.4)",
                }}
                onClick={() => setSelectedImage(cert)}
                style={{
                  background: "#fffaf3",
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: "1px solid rgba(255,200,150,0.4)",
                  cursor: "pointer",
                  transition: "all 0.4s ease",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                }}
              >
                <motion.img
                  src={cert.src}
                  alt={cert.title}
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  style={{
                    width: "100%",
                    height: "250px",
                    objectFit: "cover",
                    borderBottom: "3px solid #e4a144",
                  }}
                />
                <div
                  style={{
                    padding: "14px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#5a3a0e",
                    fontSize: "1.05rem",
                    backgroundColor: "#fffaf3",
                  }}
                >
                  {cert.title}
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* 🌌 Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            key="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.85)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              backdropFilter: "blur(8px)",
              padding: "10px",
            }}
          >
            {/* Close Button */}
            <motion.button
              onClick={() => setSelectedImage(null)}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                position: "absolute",
                top: "15px",
                right: "20px",
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: "2rem",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              &times;
            </motion.button>

            {/* Image */}
            <motion.img
              src={selectedImage.src}
              alt={selectedImage.title}
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.4 }}
              style={{
                width: "100%",
                maxWidth: "900px",
                maxHeight: "85vh",
                borderRadius: "12px",
                objectFit: "contain",
                boxShadow: "0 0 25px rgba(255,255,255,0.3)",
              }}
            />

            {/* Caption */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.2 }}
              style={{
                position: "absolute",
                bottom: "20px",
                textAlign: "center",
                color: "#fff",
                fontWeight: "600",
                fontSize: "clamp(1rem, 2.5vw, 1.3rem)",
                textShadow: "0 0 10px rgba(0,0,0,0.6)",
                padding: "0 10px",
              }}
            >
              {selectedImage.title}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Achievements;
